module.exports = __webpack_public_path__ + "img/388-0324fa.png";